export default __webpack_public_path__ + "static/media/Eni4SmugMug-CAL00263-Edit-1.218850dd.jpg";